<template>
  <div>
    <div class="advocacy-actionwidget" data-domain="p2a.co" data-shorturl="ftsNzE2" />
  </div>
</template>

<script>
export default {
  name: 'Phone2ActionWidget'
}
</script>

<!-- Boilerplate JS snippet that enables the P2A widget to function -->
<script>
(function(d, s, id) {
var js, fjs = d.getElementsByTagName(s)[0];
if (d.getElementById(id)) return;
js = d.createElement(s); js.id = id;
js.src = '//p2a.co/js/embed/widget/advocacywidget.min.js';
fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'advocacy-actionwidget-code'));
</script>

<style scoped>
  .advocacy-actionwidget{
    width: 30vw !important;
    height: 90vh !important;
    margin-left: 76px !important;
    margin-top: 20px !important;
  }
  iframe {
    height: 90vh !important;
  }

  /* start of tablet styles */
  @media screen and (max-width: 1135px) {
    .advocacy-actionwidget {
      width: 50vw !important;
    }
  }

  /* start of phone styles */
  @media screen and (max-width: 679px) {
    .advocacy-actionwidget {
      width: 100% !important;
      height: 100% !important;
      margin-left: 0px !important;
      margin-top: 0px !important;
    }
    iframe {
      height: 100vh !important;
    }
  }

</style>
